import { TabElement } from "../../components/visuals/TabOptions/TabOptions";
import voting from "../../assets/svg/voting.svg";
import votingGreen from "../../assets/svg/voting_green.svg";
import portfolio from "../../assets/svg/portfolio.svg";
import portfolioGreen from "../../assets/svg/portfolio_green.svg";
import flagWhite from "../../assets/svg/flag_white.svg";
import flagGreen from "../../assets/svg/flag_green.svg";
import { API_ROUTES } from "../../services/api/config";
import { FileOptionTabTitle } from "../../types/fileUploadTypes";
import { MESSAGES } from "../../messages";

// --- Role-Based UI Configuration ---
export interface RoleUIConfig {
  showSideMenu: boolean;
  showMagicLinkButton: boolean;
  showFileTabs: boolean;
  allowedFileTypes: FileOptionTabTitle[];
}

const FULL_ACCESS_CONFIG: RoleUIConfig = {
  showSideMenu: true,
  showMagicLinkButton: true,
  showFileTabs: true,
  allowedFileTypes: [
    FileOptionTabTitle.PORTFOLIO,
    FileOptionTabTitle.VOTING_RECORDS,
    FileOptionTabTitle.ENGAGEMENT_RECORDS,
  ],
};

const RESTRICTED_CONFIG: RoleUIConfig = {
  showSideMenu: false,
  showMagicLinkButton: false,
  showFileTabs: true,
  allowedFileTypes: [
    FileOptionTabTitle.PORTFOLIO,
    FileOptionTabTitle.VOTING_RECORDS,
    FileOptionTabTitle.ENGAGEMENT_RECORDS,
  ],
};

export const getRoleUIConfig = (isRestrictedUser: boolean): RoleUIConfig => {
  return isRestrictedUser ? RESTRICTED_CONFIG : FULL_ACCESS_CONFIG;
};

export const FILE_OPTIONS: TabElement[] = [
  {
    title: FileOptionTabTitle.PORTFOLIO,
    icon: portfolio,
    activeIcon: portfolioGreen,
    isHovered: false,
    isActive: false,
    isLocked: false,
  },
  {
    title: FileOptionTabTitle.VOTING_RECORDS,
    icon: voting,
    activeIcon: votingGreen,
    isHovered: false,
    isActive: false,
    isLocked: false,
  },
  {
    title: FileOptionTabTitle.ENGAGEMENT_RECORDS,
    icon: flagWhite,
    activeIcon: flagGreen,
    isHovered: false,
    isActive: false,
    isLocked: false,
  },
];

type FileOptionRoute = {
  upload: keyof typeof API_ROUTES;
  run: keyof typeof API_ROUTES;
  validate?: keyof typeof API_ROUTES;
  title: string;
  titleNotRunning: string;
  description: string;
  descriptionNotRunning: string;
};

export const FILE_VALIDATION_CONFIG: Record<
  FileOptionTabTitle,
  { enabled: boolean; endpoint?: keyof typeof API_ROUTES }
> = {
  [FileOptionTabTitle.PORTFOLIO]: {
    enabled: false,
    endpoint: "VALIDATE_PORTFOLIO",
  },
  [FileOptionTabTitle.VOTING_RECORDS]: {
    enabled: true,
    endpoint: "VALIDATE_VOTING",
  },
  [FileOptionTabTitle.ENGAGEMENT_RECORDS]: {
    enabled: true,
    endpoint: "VALIDATE_ENGAGEMENTS",
  },
};

export const FILE_OPTION_ROUTES_MAPPING: Record<
  FileOptionTabTitle,
  FileOptionRoute
> = {
  [FileOptionTabTitle.PORTFOLIO]: {
    upload: "UPLOAD_PORTFOLIO",
    run: "CALCULATE_COMPASS_METRICS",
    title: MESSAGES.CALCULATE_METRICS_TITLE.CALCULATING,
    titleNotRunning: MESSAGES.CALCULATE_METRICS_TITLE.NOT_CALCULATING,
    description: MESSAGES.CALCULATE_METRICS_DESCRIPTION.NOT_CALCULATING,
    descriptionNotRunning: MESSAGES.CALCULATE_METRICS_DESCRIPTION.CALCULATING,
  },
  [FileOptionTabTitle.VOTING_RECORDS]: {
    upload: "UPLOAD_VOTING_RECORDS",
    run: "PROCESS_VOTING_METRICS",
    title: MESSAGES.PROCESS_VOTING_RECORDS_TITLE.PROCESSING,
    titleNotRunning: MESSAGES.PROCESS_VOTING_RECORDS_TITLE.NOT_PROCESSING,
    description: MESSAGES.PROCESS_VOTING_RECORDS_DESCRIPTION.NOT_PROCESSING,
    descriptionNotRunning:
      MESSAGES.PROCESS_VOTING_RECORDS_DESCRIPTION.PROCESSING,
  },
  [FileOptionTabTitle.ENGAGEMENT_RECORDS]: {
    upload: "UPLOAD_ENGAGEMENT_RECORDS",
    run: "PROCESS_ENGAGEMENT_METRICS",
    title: MESSAGES.PROCESS_ENGAGEMENT_RECORDS_TITLE.PROCESSING,
    titleNotRunning: MESSAGES.PROCESS_ENGAGEMENT_RECORDS_TITLE.NOT_PROCESSING,
    description: MESSAGES.PROCESS_ENGAGEMENT_RECORDS_DESCRIPTION.NOT_PROCESSING,
    descriptionNotRunning:
      MESSAGES.PROCESS_ENGAGEMENT_RECORDS_DESCRIPTION.PROCESSING,
  },
};
